export function addClassNames(...toAdd) {
    return toAdd.filter(a => a?.length).join(" ");
}